// react
import React from 'react';

// mui
import { Box, Button, Container, Divider, Stack } from '@mui/material';

// templates
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

// organisms
import { Editor } from '@/components/organisms/Editor/Editor';
import { FieldDef } from '@/components/organisms/EditorFields/fieldHelper';

export interface OrganizationEditorPageProps {
  title: string;
  fields: Record<string, FieldDef>;
  value: any;
  onChange: (value: any, key: string) => void;
  onBack: () => void;
  onSave: () => void;
  saveLabel?: string;
  isSaveDisabled?: boolean;
  inviteKeySlot?: React.ReactNode;
}

/**
 * OrganizationEditorPage provides the page design for creating/editing an organization.
 */
export const OrganizationEditorPage = ({
  title,
  fields,
  value,
  onChange,
  onBack,
  onSave,
  saveLabel = 'Save',
  isSaveDisabled = false,
  inviteKeySlot,
}: OrganizationEditorPageProps) => {
  return (
    <ModalPageTemplate
      onBack={onBack}
      footerSlot={
        <Box
          sx={{
            bgcolor: 'background.default',
          }}
        >
          <Divider />
          <Container maxWidth='sm'>
            <Stack
              direction='row'
              spacing={2}
              sx={{
                py: 2,
              }}
            >
              <Button variant='outlined' fullWidth onClick={onBack}>
                Cancel
              </Button>
              <Button
                variant='contained'
                fullWidth
                onClick={onSave}
                disabled={isSaveDisabled}
              >
                {saveLabel}
              </Button>
            </Stack>
          </Container>
        </Box>
      }
    >
      <PageTemplate
        maxWidth='sm'
        headerSlot={<PageHeader title={title} />}
        contentSlot={
          <Stack spacing={4}>
            {inviteKeySlot}
            <Editor
              isActionsDisabled
              isFloatingActions={false}
              isForm={false}
              value={value}
              onChange={onChange}
              fields={fields}
            />
          </Stack>
        }
      />
    </ModalPageTemplate>
  );
};

OrganizationEditorPage.displayName = 'OrganizationEditorPage';
export default OrganizationEditorPage;
